import { PrstTransform } from '../../prst-transform/prst-transform';
import { Area, Point, PrstTxWarp } from '../../type/common.interface';

export function transformNode(prstTxWarp: PrstTxWarp, contentArea: Area, pointsList: Point[][]) {
    const transformedPointsList = pointsList.map(points =>
        points.map(point => PrstTransform.getInstance().getTransformedPoint(prstTxWarp, contentArea, point)));
    return transformedPointsList;
}
